const menu = [
    {
        id : 'shouye',
        path : '/fillout',
        title : "月报填报",
        icon : 'el-icon-my-tianbao'
    },
    {
        id : 'sjcj',
        path : '/check',
        title : "月报审核",
        icon : 'el-icon-my-shenpi'
    }
]

export default menu



// WEBPACK FOOTER //
// ./src/static/menu.js